import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useAuthStore } from './store';
import { useAuthSheets } from './authSheetContext';
import { enrichGatedOtpParams } from './otpSheetPolicy';
import { peekSelectedSubscription } from '../../data/domains/subscription';

/**
 * On screens that require OTP verification (Profile, Checkout, etc.), call this hook.
 * While the user is logged in but unverified, re-opens the OTP sheet on focus until verified.
 */
export function useRequireVerified(redirect_to_screen: string): void {
  const { openOtp, state } = useAuthSheets();
  const user = useAuthStore(s => s.user);

  useFocusEffect(
    useCallback(() => {
      if (!user?.id || user.is_verified !== false) {
        return;
      }
      if (state?.kind === 'otp') {
        return;
      }
      openOtp(
        enrichGatedOtpParams({
          phone: user.phone ?? '',
          countryCode: '+965',
          context: 'signin',
          redirectTo: redirect_to_screen,
          checkoutPayload: redirect_to_screen === 'Checkout' ? peekSelectedSubscription() : undefined,
        }),
      );
    }, [user?.id, user?.is_verified, user?.phone, redirect_to_screen, openOtp, state?.kind]),
  );
}
